import { useState, useEffect } from 'react';

type SelectOption = {
  label: string;
  value: string;
};

interface SelectOptionProps {
  options: SelectOption[];
  selectedValue?: string;
  name: string;
  initialLabel: string;
  onChangeCallback: (value: string) => void;
  customClasses?: string;
  isDisabled?: boolean;
}

export const SelectOption = ({
  options,
  name,
  selectedValue = '',
  initialLabel = 'Select an option',
  onChangeCallback,
  customClasses,
  isDisabled = false,
}: SelectOptionProps) => {
  const [selectedOption, setSelectedOption] = useState(selectedValue);

  useEffect(() => {
    setSelectedOption(selectedValue);
  }, [selectedValue]);

  const handleChange = (value) => {
    setSelectedOption(value);
    onChangeCallback(value);
  };

  return (
    <div className={`select-option ${customClasses || ''}`}>
      <select
        name={name}
        onChange={(e) => handleChange(e.target.value)}
        value={selectedOption}
        disabled={isDisabled}
      >
        <option value="" disabled>
          {initialLabel}
        </option>
        {options.map((option) => (
          <option key={`${option.value}-schedule-select`} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};
